import Title from '@/components/Form/Title'

const ModalTos = ({ onClick }: { onClick: () => void }) => (
  <>
    <input type="checkbox" id="modal_tos" className="modal-toggle" />
    <div className="modal" role="dialog">
      <div className="modal-box w-11/12 max-w-4xl px-10 pb-20">
        <Title title="Termos de Uso" />

        <iframe
          src="/TERMOS-APP_ENERGIA.pdf#zoom=100"
          width="100%"
          height="100%"
          className="mb-4"
          style={{ border: 'none', width: '100%', height: '70vh' }}
        ></iframe>
        <div className="modal-action">
          <label
            htmlFor="modal_tos"
            className="btn-primaty btn btn-success btn-lg btn-block text-white"
          >
            {' '}
            <div onClick={() => onClick()}>Aceito os termos de uso</div>
          </label>
        </div>
      </div>
    </div>
  </>
)

export default ModalTos
